module.exports = __webpack_public_path__ + "assets/img/JLD_Ariel View_RGB_lr.541a8589.jpg";